import { render, staticRenderFns } from "./PaperQuestion.vue?vue&type=template&id=006819f9&scoped=true&lang=html&"
import script from "./PaperQuestion.vue?vue&type=script&lang=js&"
export * from "./PaperQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PaperQuestion.vue?vue&type=style&index=0&id=006819f9&scoped=true&lang=less&rel=stylesheet%2Fless&"
import style1 from "./PaperQuestion.vue?vue&type=style&index=1&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006819f9",
  null
  
)

export default component.exports